import { render, staticRenderFns } from "./PropertyBedroomSelection.vue?vue&type=template&id=2de6b60f&"
import script from "./PropertyBedroomSelection.vue?vue&type=script&lang=js&"
export * from "./PropertyBedroomSelection.vue?vue&type=script&lang=js&"
import style0 from "./PropertyBedroomSelection.vue?vue&type=style&index=0&id=2de6b60f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports